import axios from 'axios'
import * as FileSaver from 'file-saver'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import { XML_TYPE } from 'Utilities'

const INCOMPATIBLE_MESSAGE = 'El archivo que subiste no es compatible'

const DEFAULT_RESULT_XLSX_NAME = 'Detalle descuento por producto convencional.xlsx'

function filenameFromContentDisposition(header) {
  if (!header || typeof header !== 'string') return null
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header)
  if (star && star[1]) {
    try {
      return decodeURIComponent(star[1].trim())
    } catch (_e) {
      return null
    }
  }
  const q = /filename="([^"]+)"/i.exec(header)
  if (q && q[1]) return q[1].trim()
  const plain = /filename=([^;]+)/i.exec(header)
  if (plain && plain[1]) return plain[1].trim().replace(/^["']|["']$/g, '')
  return null
}

/**
 * Importación masiva de bonificaciones (PDP). Mismo contrato de parámetros que el export.
 * Convencional + por producto, convencional + por stock o usados + por stock: descarga automática del Excel de resultado.
 *
 * @param {Object} p
 * @param {File} p.file
 * @param {string} p.carLotId
 * @param {string} p.businessType convenctional | used
 * @param {string} p.discountType byProduct | byStock
 */
export async function postBonificationsMassImport({
  file,
  carLotId,
  businessType,
  discountType,
}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('carlotid', String(carLotId))
  formData.append('businessType', businessType)
  formData.append('discountType', discountType)

  try {
    const response = await axios.post(
      `${CATALOGO_ENDPOINT}/uploadBonificationsMassPriceFile`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 300000,
        responseType: 'blob',
      },
    )

    const name =
      filenameFromContentDisposition(response.headers['content-disposition']) ||
      DEFAULT_RESULT_XLSX_NAME
    const blob = new Blob([response.data], { type: XML_TYPE })
    FileSaver.saveAs(blob, name)

    const appliedRaw = response.headers['x-bonifications-applied']
    const totalRaw = response.headers['x-bonifications-total']

    let applied = 0
    if (appliedRaw !== undefined && appliedRaw !== '') {
      const n = Number(appliedRaw)
      if (Number.isFinite(n)) applied = n
    }

    let totalImported = applied
    if (totalRaw !== undefined && totalRaw !== '') {
      const n = Number(totalRaw)
      if (Number.isFinite(n)) totalImported = n
    }
    return {
      ok: true,
      downloadedResultFile: true,
      applied,
      totalImported,
    }
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      let parsed = null
      try {
        const text = await err.response.data.text()
        parsed = JSON.parse(text)
      } catch (_e) {
        parsed = null
      }
      const backendMsg =
        parsed &&
        typeof parsed.message === 'string' &&
        parsed.message.trim() !== ''
          ? parsed.message.trim()
          : null
      const msg = backendMsg || INCOMPATIBLE_MESSAGE
      const next = new Error(msg)
      next.response = {
        ...err.response,
        data:
          parsed && typeof parsed === 'object'
            ? { ...parsed, message: msg }
            : { message: msg },
      }
      throw next
    }
    throw err
  }
}

export { INCOMPATIBLE_MESSAGE }

// Mapea error HTTP a mensaje para el toast.
export function getBonificationsImportErrorMessage(error) {
  const m = error?.response?.data?.message
  if (typeof m === 'string' && m.trim() !== '') return m
  if (error?.message && /Network|timeout/i.test(String(error.message))) {
    return 'No se pudo completar la importación. Intentá de nuevo.'
  }
  return INCOMPATIBLE_MESSAGE
}
